import { useContext } from "react";
import { SnackbarContext } from "../feedback/AppSnackbar";

const useSnackbar = () => {
    const context = useContext(SnackbarContext);

    if (!context) {
        throw new Error("useSnackbar must be used within AppSnackbar");
    }

    return context;
};

export default useSnackbar; // ✅ IMPORTANT